<template>
  <div class="group_wrap">
    <BreadCrumb crumb="管理员管理"></BreadCrumb>
    <div class="top_bar">
      <el-row>
        <el-col :span="5">
          <el-input placeholder="请输入搜索内容: 账号/用户名" v-model="keyword" class="input-with-select" size="small">
            <!-- <el-button slot="append" icon="el-icon-search" @click="fnGetData(1)"></el-button> -->
          </el-input>
        </el-col>
      <el-col :span="5" :offset='1'>
          <template>
            <el-select  size="small" v-model="status" placeholder="请选择状态">
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
      </el-col>

      <el-col :span="2" >
        <div class="find" @click='fnGetData(1)'>查询</div>
      </el-col>

        <AddAdmin @fnResetTable="fnGetData" :options='aGroupList'></AddAdmin>
      </el-row>
    </div>
    <AdminTable :admins="aAdminList" @fnResetTable="fnGetData"></AdminTable>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pages"
      :current-page="page"
      style="text-align:center;margin-top:10px"
      @current-change="fnGetPage"
      >
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import AddAdmin from '@/components/widget/AddAdmin'
import AdminTable from '@/components/widget/AdminTable'
import cons from '@/components/constant'
export default {
  name: 'Admin',
  data () {
    return {
      options1: [{
          value: '0',
          label: '禁用'
        },
        {
          value: '1',
          label: '启用'
        }
      ],
      status: '',
      keyword: '',
      page:1,
      pages:8,
      pagesize:10,
      aAdminList:[],
      aGroupList:[]
    }
  },
  components:{
    BreadCrumb,
    AddAdmin,
    AdminTable
  },
  mounted(){
    this.fnGetData(1);

    let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/groups', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json'
      })
      .then(dat=>{
          this.aGroupList = dat.data.data.groups;
      }).catch(err=>{
         console.log(err);
      });
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/administrators', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            page:num,
            order_by: 'id',
            status: this.status===''?1:this.status,
            keyword: this.keyword,
            per_page:this.pagesize
          }
      }, {
          withCredentials: true
        })
      .then(dat=>{
          this.aAdminList = dat.data.data.administrators;
          this.page = num;
          this.pages = dat.data.data.total_count;
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    }
  }
}
</script>

<style scoped>
.top_bar{
    width:95.2%;
    overflow:hidden;
    margin:10px auto;
  }


  .find {
  width: 92px;
  height: 38px;
  color: #fff;
  font: 12px/38px 'simsun';
  text-align: center;
  background-color: #FB5557;
  border-radius: 3px;
  cursor: pointer;
}
.find {
  width: 80px;
  height: 32px;
  line-height: 32px;
  margin-left: 140px;
}
.batch_operation:hover, .export_data:hover, .find:hover {
  background-color: rgb(252, 119, 121);
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin.vue